import { useStore, useStoreMap } from 'effector-react'
import { DebtStatusesEnum } from '~/shared/config/enums'
import { formatDateForUI, formatDateTimeForUI } from '~/shared/lib/date'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { parseSumForUi } from '~/shared/lib/utils'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { $debt, openRepayDrawer } from './model'
import {
  ContentWrapper,
  Descriptions,
  ItemTitle,
  ItemValue,
  ItemWrapper,
  Title,
} from './styled'

export const ViewDebt = () => {
  const debt = useStoreMap($debt, (debt) => debt?.getAttributes())
  const sourceTitle = useStoreMap($debt, (debt) => debt?.getSourceTitle())
  const carPlateNumber = useStoreMap($debt, (debt) =>
    debt?.getCar()?.getPlateNumber(),
  )
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const isProcessing = debt?.status === DebtStatusesEnum.PROCESSING

  if (!debt) return null

  return (
    <>
      <Title>
        Задолженность от <br />
        {debt.createdAt ? formatDateTimeForUI(debt.createdAt) : '-'}
      </Title>
      <Descriptions>{debt.sourceTypeLabel || debt.sourceType}</Descriptions>

      <ContentWrapper>
        <ItemWrapper>
          <ItemTitle>Автомобиль</ItemTitle>
          <ItemValue>{carPlateNumber || 'Автомобиль не найден'}</ItemValue>
        </ItemWrapper>
        <ItemWrapper>
          <ItemTitle>Основание</ItemTitle>
          <ItemValue>{sourceTitle || '-'}</ItemValue>
        </ItemWrapper>
        <ItemWrapper>
          <ItemTitle>Дата начала списания</ItemTitle>
          <ItemValue>
            {debt.startedAt ? formatDateForUI(debt.startedAt) : '-'}
          </ItemValue>
        </ItemWrapper>
        <ItemWrapper>
          <ItemTitle>Сумма</ItemTitle>
          <ItemValue>{parseSumForUi(debt.total)}</ItemValue>
        </ItemWrapper>
        <ItemWrapper>
          <ItemTitle>В день</ItemTitle>
          <ItemValue>{parseSumForUi(debt.paymentCost)}</ItemValue>
        </ItemWrapper>
        <ItemWrapper>
          <ItemTitle>Списано</ItemTitle>
          <ItemValue>{parseSumForUi(debt.paid)}</ItemValue>
        </ItemWrapper>
        <ItemWrapper style={{ border: 'none' }}>
          <ItemTitle>Осталось списать</ItemTitle>
          <ItemValue style={{ color: myPalette.coral.main }}>
            {parseSumForUi(debt.remainingAmount)}
          </ItemValue>
        </ItemWrapper>
      </ContentWrapper>

      {isProcessing && featureFlags.debt_early_repayment && (
        <Button
          fullWidth
          variant='limeFlooded'
          size='large'
          onClick={() => openRepayDrawer()}
          style={{ marginTop: '24px' }}
        >
          Оплатить досрочно
        </Button>
      )}
    </>
  )
}
